import { observable, computed, action, IObservableArray } from "mobx";

import * as DocumentReader from "../DocumentReader";
import { DocumentSearchStore } from "./DocumentSearchStore";
import { WizardStore, IWizardStore } from "./AppStore";
import { Strings } from "../Stores/StringsStore";
import * as Shared from "../Shared";

export class AdditionalFilterValuesWizardStore extends WizardStore implements IWizardStore {

	constructor(public documentSearchStore: DocumentSearchStore) {
		super();
	}

  /**
  * The focused filter to add further filter values to.
  */
	currentFilterToAddFilterValues: DocumentReader.DocumentSearchFilter = null;
	/*
	* Stores addiional filter values
	*/
	additionalFilterValues: IObservableArray<DocumentReader.SearchFilterValue> = observable.array([]);

	/**
   * Search term for filter
   */
	@observable searchTerm: string = "";

	searchTimeoutHandle: number;
  /**
   * All selected filter values to add to the current filter.
   */
	selectedAdditionalFilterValues: IObservableArray<DocumentReader.SearchFilterValue> = observable.array([]);

  /**
* Open the wizard for adding filter values to the current filter.
*/
	open = (): void => {
		this.wizardInformation = Strings.reader.addAdditionalFilterValuesText;
		this.isOpen = true;
	}

  /**
 * Callback for confirming the wizard operation.
 */
	@action onConfirmWizard = () => {
		this.isOpen = false;
		if (this.selectedAdditionalFilterValues.length == 0) return;
		if (this.currentFilterToAddFilterValues.filterMode == Shared.FilterMode.Single) {
			this.documentSearchStore.resetFilterValuesOfTypeSingle(this.selectedAdditionalFilterValues[0], this.currentFilterToAddFilterValues.values);
		}
		this.selectedAdditionalFilterValues.forEach(selectedFilterValue => {
			let currentFilterValue = this.currentFilterToAddFilterValues.values.find(currentFilterValues => { return currentFilterValues.value == selectedFilterValue.value; });
			if (currentFilterValue) {
				currentFilterValue.isSelected = selectedFilterValue.isSelected;
			}
			else {
				currentFilterValue = selectedFilterValue;
				this.currentFilterToAddFilterValues.values.push(currentFilterValue);
			}
			this.documentSearchStore.setDocumentFilter(this.currentFilterToAddFilterValues, currentFilterValue);
		});
		this.documentSearchStore.triggerSearch(false);
		this.selectedAdditionalFilterValues.clear();
	}

	/**
	* Callback fro canceling the wizard operation.
	*/
	@action onCancelWizard = () => {
		this.isOpen = false;
		this.selectedAdditionalFilterValues.clear();
	}

	/**
	* reset the Additional filter value selection wizard box search term and model
	*/
	resetWizardBox = () => {
		this.searchTerm = "";
		this.additionalFilterValues.clear();
	}

	/**
	 * Load additional filter values
	 */
	@action loadAdditionalFilterValues() {
		this.isWizardBoxBusy = true;
		let query: DocumentReader.MoreFilterValuesQuery = new DocumentReader.MoreFilterValuesQuery();
		query.name = this.currentFilterToAddFilterValues.name;
		query.query = this.documentSearchStore.currentDocumentQuery;
		if (this.searchTerm) {
			query.searchExpression = this.searchTerm;
		}
		DocumentReader.getDocumentSearchFilterAllValuesAsync(query).then((additionalFilters) => {
			this.additionalFilterValues.replace(additionalFilters.values);
			this.additionalFilterValues.forEach(value => {
				value.isSelected = this.currentFilterToAddFilterValues.values.some(availableFilterValue => availableFilterValue.value == value.value && value.isSelected);
			});
			this.isWizardBoxBusy = false;
		});
	}

}